import PostMerchantBlueThumb from '@components/Post/MerchantBlueThumb';
import { Resource } from '@core';
import { mc, StyleProps } from '@styles';
import { TestIdProps } from '@utils';
import React, { FC } from 'react';

import ChevronRightIcon from './assets/chevronRight.inline.svg';
import * as styles from './singleMerchantWidget.module.css';

interface Props extends StyleProps, TestIdProps {
  merchant: Resource;
}

export const PostSingleMerchantWidget: FC<Props> = ({ testId, className, style, merchant }) => {
  const { webImage, merchantName, webDescription, webLink } = merchant;
  return (
    <a
      data-testid={testId}
      style={style}
      className={mc('py-8', 'flex flex-row items-start', 'border-t border-b border-neutral-gray', className)}
      target="_blank"
      href={webLink}
    >
      {!!webImage && <PostMerchantBlueThumb className="w-28 h-28 md:w-32 md:h-32" merchant={merchant} />}
      <div className={mc('px-8 -mt-1', 'flex-1 self-stretch', 'flex flex-col')}>
        <div className="flex-1">
          <h6 className={mc('m-0 p-0', 'text-xl font-raleway leading-normal font-bold text-ocean-blue')}>{merchantName}</h6>
          <p className={mc('m-0 p-0 mt-2', 'font-raleway leading-normal font-medium text-ocean-blue', styles.description)}>
            {webDescription}
          </p>
        </div>
        <div className={mc('mt-3', 'flex flex-row')}>
          <span
            className={mc(
              'flex flex-row items-center',
              'fill-ocean-blue text-ocean-blue font-medium',
              'hover:text-accent-orange hover:fill-accent-orange',
            )}
          >
            <span className="block mr-2">Learn More</span>
            <ChevronRightIcon />
          </span>
        </div>
      </div>
    </a>
  );
};

export type PostSingleMerchantWidgetProps = Props;
export default PostSingleMerchantWidget;
